import { ProductHighlightAdminCg3 } from '@diamond/shared/types';
import { apiInstance } from '@diamond/shared/utils';
import { useAuthStore } from '@diamond/sol-admin/features/auth';
import { useInfiniteQuery } from '@tanstack/react-query';

import {
  BACKOFFICE_HIGHLIGHT_QUERY_KEY,
  ENDPOINT_PRODUCT_HIGHLIGHT_CG3,
} from '../constant';

export type BackofficeGetManyHighlightsQuery = {
  size: number;
  page: number;
  search_query?: string;
  business_type?: string[];
  business_type_desc?: string[];
  business_segmentation?: string[];
  distribution_channel?: string[];
  sap_no_shipto?: string[];
};

async function getHighlightsListCg3(
  token: string,
  params: BackofficeGetManyHighlightsQuery
) {
  const { page, size, ...rest } = params;
  const { data } = await apiInstance(token).get<ProductHighlightAdminCg3>(
    ENDPOINT_PRODUCT_HIGHLIGHT_CG3,
    {
      params: { page, size, ...rest },
    }
  );

  return {
    data: data.data,
    pagination: data.pagination,
    nextPage: page < data.pagination.pages ? page + 1 : null,
  };
}

export function useHighlightsListInfinite(
  queryParams: BackofficeGetManyHighlightsQuery,
  options: { enabled?: boolean } = {}
) {
  const { access_token } = useAuthStore();

  return useInfiniteQuery({
    queryKey: [BACKOFFICE_HIGHLIGHT_QUERY_KEY, queryParams],
    queryFn: ({ pageParam }) =>
      getHighlightsListCg3(access_token, { ...queryParams, page: pageParam }),
    initialPageParam: queryParams.page ?? 1,
    getNextPageParam: ({ nextPage }) => nextPage,
    gcTime: 0,
    enabled: options.enabled ?? true,
  });
}
